import { CompositionCell as CompositionCellComponent  } from './CompositionCell.component'
import { connector } from './CompositionCell.connector'

export const CompositionCell = connector(CompositionCellComponent)